import { CommonModule } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import {
  AbstractControlOptions,
  FormBuilder,
  FormControl,
  FormGroup,
  ReactiveFormsModule,
  Validators,
} from '@angular/forms';
import { ActivatedRoute } from '@angular/router';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { AuthService } from '@noovle/core';
import { LoadingComponent } from '@noovle/ui-libraries';
import { passwordMatchValidator, patternValidator, validatePassword } from '@noovle/utilities';
@Component({
  selector: 'app-reset-password',
  templateUrl: './reset-password.component.html',
  styleUrls: ['./reset-password.component.scss'],
  standalone: true,
  imports: [CommonModule, FontAwesomeModule, LoadingComponent, ReactiveFormsModule],
})
export class ResetPasswordComponent implements OnInit {
  pwdForm: FormGroup;
  email = '';
  uuidFirebase = '';
  checkToken = '';
  errorReset = false;
  completeReset = false;
  calling = false;
  message: string;
  criterias: any[] = [];
  hasCheckOldPassword = false;
  constructor(
    public formBuilder: FormBuilder,
    private route: ActivatedRoute,
    private authService: AuthService,
    public activeModal: NgbActiveModal
  ) {
    this.criterias = [
      {
        type: 'minlength',
        message: 'Almeno 8 caratteri',
        checkError: (type: string) =>
          this.pwdForm?.get('newpassword')?.hasError(type),
      },
      {
        type: 'hasNumber',
        message: 'Almeno un numero',
        checkError: (type: string) =>
          this.pwdForm?.get('newpassword')?.hasError(type),
      },
      {
        type: 'hasCapitalCase',
        message: 'Almeno una lettera maiuscola',
        checkError: (type: string) =>
          this.pwdForm?.get('newpassword')?.hasError(type),
      },
      {
        type: 'hasSmallCase',
        message: 'Almeno una lettera minuscola',
        checkError: (type: string) =>
          this.pwdForm?.get('newpassword')?.hasError(type),
      },
      {
        type: 'hasSpecialCharacters',
        message: 'Almeno un carattere speciale',
        checkError: (type: string) =>
          this.pwdForm?.get('newpassword')?.hasError(type),
      },
      {
        type: 'pwdMacth',
        message: 'La nuova password deve essere diversa dalla precedente',
        checkError: () =>
          this.pwdForm?.get('oldPassword')?.value ===
          this.pwdForm?.get('newpassword')?.value,
      },
    ];
  }

  ngOnInit() {
    this.email =
      this.route.snapshot.queryParamMap.get('email') ||
      this.authService.providerDataUser?.email ||
      '';
    this.uuidFirebase =
      this.route.snapshot.queryParamMap.get('uuidFirebase') || '';
    this.checkToken = this.route.snapshot.queryParamMap.get('checkToken') || '';
    this.pwdForm = this.formBuilder.group(
      {
        email: new FormControl(
          this.email,
          this.hasCheckOldPassword ? [] : [Validators.required]
        ),
        oldPassword: [
          '',
          this.hasCheckOldPassword
            ? {
                validators: [Validators.required],
                asyncValidators: [validatePassword(this.authService)],
                updateOn: 'blur',
              }
            : [],
        ],
        newpassword: new FormControl(
          '',
          Validators.compose([
            Validators.required,
            patternValidator(/.{8,}/, { minlength: true }),
            patternValidator(/\d/, { hasNumber: true }),
            patternValidator(/[A-Z]/, { hasCapitalCase: true }),
            patternValidator(/[a-z]/, { hasSmallCase: true }),
            patternValidator(/[$@!%*?&<>\\.]/, { hasSpecialCharacters: true }),
          ])
        ),
        confirmpassword: new FormControl('', [Validators.required]),
      },
      {
        validators: passwordMatchValidator,
      } as AbstractControlOptions
    );
  }

  resetPassword() {
    this.calling = true;
    (!this.hasCheckOldPassword &&
      this.authService
        .resetPassword(
          this.uuidFirebase,
          this.checkToken,
          this.pwdForm.get('newpassword')?.value
        )
        .subscribe({
          error: () => {
            this.calling = false;
            this.errorReset = true;
            this.message =
              'Si è verificato un errore. Non è stato possibile aggiornare la password. Riprovare.';
          },
          complete: () => {
            this.calling = false;
            this.completeReset = true;
            this.message = 'La password è stata aggiornata correttamente.';
          },
        })) ||
      this.authService
        .updatePassword(this.pwdForm.get('newpassword')?.value)
        .subscribe({
          error: () => {
            this.calling = false;
            this.errorReset = true;
            this.message =
              'Si è verificato un errore. Non è stato possibile aggiornare la password. Riprovare.';
          },
          complete: () => {
            this.calling = false;
            this.completeReset = true;
            this.message = 'La password è stata aggiornata correttamente.';
          },
        });
  }

  checkEqualPwds() {
    return this.pwdForm
      ?.get('newpassword')
      ?.value.startsWith(this.pwdForm?.get('confirmpassword')?.value);
  }
}
